<template>
  <div>
    <div class="row">
      <div v-for="field in documentFields" class="col-sm-3">
        <b>{{$t(`result.context.header.document.${field}`)}}:</b>
        {{$tOr(`filters.ncs_documents.${field}.options`, document[field])}}
      </div>
      <div class="col-sm-12">
        <b>{{$t('result.context.header.document.title')}}:</b> {{document.title}}
      </div>
    </div>
  </div>
</template>
<script>
  export default {
    props: ['document', 'text'],
    data() {
      return {
        documentFields: ['subcorpus', 'language', 'text_genre', 'text_subgenre', 'year', 'specialization', 'code']
      }
    }
  }
</script>
